import { render, staticRenderFns } from "./BackendTranslatedText.vue?vue&type=template&id=67bae666"
import script from "./BackendTranslatedText.vue?vue&type=script&lang=js"
export * from "./BackendTranslatedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports